import { Resource } from '.';

export interface ResourceResponceDTO {
  docs: Resource[];
}
